import { Component } from '@angular/core';

@Component({
  selector: 'app-mobile-base-route',
  templateUrl: './mobile-base-route.component.html',
  styleUrl: './mobile-base-route.component.scss',
})
export class MobileBaseRouteComponent {}
